import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PickupLocationsDialogComponent } from './pickup-locations-dialog/pickup-locations-dialog.component';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatRippleModule } from '@angular/material/core';
import { AddNewLocationDialogComponent } from './add-new-location-dialog/add-new-location-dialog.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatDialogModule } from '@angular/material/dialog';
// import { AgmCoreModule } from '@agm/core';
import { GooglePlaceModule } from 'ngx-google-places-autocomplete';
import { MatSelectModule } from '@angular/material/select';
import { PromoCodesDialogComponent } from './promo-codes-dialog/promo-codes-dialog.component';
import { AddBulkDropoffDialogComponent } from './add-bulk-dropoff-dialog/add-bulk-dropoff-dialog.component';
import { ConfirmationDialogComponent } from './confirmation-dialog/confirmation-dialog.component';
import { PaymentLayoutComponent } from './payment-layout/payment-layout.component';
import { InfoDialogComponent } from './info-dialog/info-dialog.component';
import { SelectCountryDialogComponent } from './select-country-dialog/select-country-dialog.component';
import { SearchCityGoogleMapDialogComponent } from './search-city-google-map-dialog/search-city-google-map-dialog.component';
import { CancelOrderReasonsComponent } from './cancel-order-reasons/cancel-order-reasons.component';
import { MatRadioModule } from '@angular/material/radio';
import { TrackDriverComponent } from './track-driver/track-driver.component';
// import { AgmDirectionModule } from 'agm-direction';
import { OtpDialogComponent } from './otp-dialog/otp-dialog.component';
import { NgOtpInputModule } from 'ng-otp-input';
import { WindowService } from '../services/windows.service';
import { ForgotPasswordMethodsComponent } from './forgot-password-methods/forgot-password-methods.component';
import { OtpVerificationDialogComponent } from './otp-verification/otp-verification-dialog/otp-verification-dialog.component';
import { AngularFireModule } from '@angular/fire/compat';
import { ResetPasswordDialogComponent } from './reset-password-dialog/reset-password-dialog.component';
import { WhatToSendDialogComponent } from './what-to-send-dialog/what-to-send-dialog.component';
import { AddBusinessNameDialogComponent } from './add-business-name-dialog/add-business-name-dialog.component';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { NoDriverAvailableDialogComponent } from './no-driver-available-dialog/no-driver-available-dialog.component';
import { AutoSuggestPromoComponent } from './auto-suggest-promo/auto-suggest-promo.component';
import { CommonInputDialogComponent } from './common-input-dialog/common-input-dialog.component';
import { WalletInfoDialogComponent } from './wallet-info-dialog/wallet-info-dialog.component';
import { RouterModule } from '@angular/router';
import { AllDiscountListDialogComponent } from './all-discount-list-dialog/all-discount-list-dialog.component';
import { OrderClosureDetailDialogComponent } from './order-closure-detail-dialog/order-closure-detail-dialog.component';
import { NoSpacesDirective } from '../directive/no-spaces.directive';
import { ShareModuleModule } from '../directive/share-module.module';
import { ImportDropoffLocationsDialogComponent } from './import-dropoff-locations-dialog/import-dropoff-locations-dialog.component';
import { NgxFileDropModule } from 'ngx-file-drop';
import { AffiliateAppSuggestionDialogComponent } from './affiliate-app-suggestion-dialog/affiliate-app-suggestion-dialog.component';

import { FeedbackSubmitComponent } from './feedback-submit/feedback-submit.component';
import { GoogleMapsModule } from '@angular/google-maps';
import { AutoUpdateDialogComponent } from './auto-update-dialog/auto-update-dialog.component';
import { InfoDialog2Component } from './info-dialog2/info-dialog2.component';
import { WebDestinationsDialogComponent } from './web-destinations-dialog/web-destinations-dialog.component';
import { EmailSentDialogComponent } from './email-sent-dialog/email-sent-dialog.component';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';

@NgModule({
  declarations: [
    PickupLocationsDialogComponent,
    AddNewLocationDialogComponent,
    PromoCodesDialogComponent,
    AddBulkDropoffDialogComponent,
    ConfirmationDialogComponent,
    PaymentLayoutComponent,
    InfoDialogComponent,
    SelectCountryDialogComponent,
    SearchCityGoogleMapDialogComponent,
    CancelOrderReasonsComponent,
    TrackDriverComponent,
    OtpDialogComponent,
    ForgotPasswordMethodsComponent,
    OtpVerificationDialogComponent,
    ResetPasswordDialogComponent,
    WhatToSendDialogComponent,
    AddBusinessNameDialogComponent,
    NoDriverAvailableDialogComponent,
    AutoSuggestPromoComponent,
    CommonInputDialogComponent,
    WalletInfoDialogComponent,
    AllDiscountListDialogComponent,
    OrderClosureDetailDialogComponent,
    ImportDropoffLocationsDialogComponent,
    AffiliateAppSuggestionDialogComponent,
    FeedbackSubmitComponent,
    AutoUpdateDialogComponent,
    InfoDialog2Component,
    WebDestinationsDialogComponent,
    EmailSentDialogComponent,
  ],
  imports: [
    CommonModule,
    MatDialogModule,
    MatInputModule,
    NgOtpInputModule,
    ShareModuleModule,
    NgxFileDropModule,
    MatProgressBarModule,
    MatRippleModule,
    GooglePlaceModule,
    RouterModule,
    MatProgressSpinnerModule,
    MatSelectModule,
    // AgmDirectionModule,
    MatButtonModule,
    ReactiveFormsModule,
    FormsModule,
    AngularFireModule,
    // AgmCoreModule,
    MatRadioModule,
    MatFormFieldModule,
    MatIconModule,
    GoogleMapsModule,
    MatSlideToggleModule,
  ],
  exports: [
    PickupLocationsDialogComponent,
    AddNewLocationDialogComponent,
    AddBulkDropoffDialogComponent,
  ],
  entryComponents: [
    PickupLocationsDialogComponent,
    AddNewLocationDialogComponent,
    AddBulkDropoffDialogComponent,
  ],
  providers: [WindowService],
})
export class DialogModule {}
